export enum CampaignEditPageKind {
  Create,
  Edit
}
